import "babel-polyfill";
import binder from "./libs/binder";
import slick from "slick-carousel";
import "./libs/jcf";
import "./libs/jcf.select";
import "./libs/jcf.scrollable";
import {
    constants,
} from "./modules/module";
import {noDev} from "./modules/noDev";
import {dropdown} from "./modules/dropdown";
import {footerNavigation} from "./modules/footerNavigation";
import {tabs} from "./modules/tabs";
import {headerNav} from "./modules/headerNav";
import {headerSearch} from "./modules/headerSearch";
import {langSwitcher} from "./modules/langSwitcher";
import {videoPlayer} from "./modules/videoPlayer";
import {popups} from "./modules/popups";
import {newsFilter} from "./modules/newsFilter";
import {socials} from "./modules/socials";
import {customSelect} from "./modules/customSelect";
import {anchors} from "./modules/anchors";
import {toggleBio} from "./modules/toggleBio";
import {productSlider} from "./modules/productSlider";
import {productAside} from "./modules/productAside";
import {topMenu} from "./modules/topMenu";
import { headerHeight } from "./modules/headerHeight";
import { wSelectBlock } from "./modules/wSelectBlock";

binder({
    bounds: {
        "html": [constants, noDev],
        ".dropdown": dropdown,
        ".footer-nav": footerNavigation,
        ".tabs": tabs,
        ".main-header": [headerNav, headerHeight],
        ".header-search": headerSearch,
        ".lang-switcher": langSwitcher,
        ".video-wrap": videoPlayer,
        ".popups": popups,
        ".news": newsFilter,
        ".sharing": socials,
        "select": customSelect,
        ".anchors": anchors,
        ".teams": toggleBio,
        ".product-slider": productSlider,
        ".sidebar": productAside,
        ".top-menu": topMenu,
        ".double-select-block": wSelectBlock
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js